// Keep in sync with CREATOR_NICHES in backend/server.py.
export const NICHES = [
    "Food",
    "Fitness",
    "Beauty",
    "Fashion",
    "Travel",
    "Local life",
    "Health and wellness",
    "Therapy and bodywork",
    "Skin and aesthetics",
    "Parenting",
    "Home and interiors",
    "Sports",
    "Outdoors",
    "Photography",
    "Art and design",
    "Music",
    "Comedy",
    "Tech and gaming",
    "Business and careers",
    "Personal finance",
    "Cars",
    "Pets",
    "Education",
    "Events and nightlife",
    "Other",
];
export const MAX_TAGS = 6;
